import MedalTilt from '../../../preloader/Medaile'
import './MainRating.css'

export interface MainRatingProps {
	rating: number;
	level: number;
	withoutUnderlying?: boolean;
	name?: string;
}

export const MainRating = ({ rating, level, withoutUnderlying, name }: MainRatingProps) => {

	return (
		<>
			<div
				className='main-rating'>
				<div className='main-rating-picture'>
					{!withoutUnderlying && <img 
						src='/achievements/medal_tilt_underlying.webp'
						alt='medal_tilt_underlying'
						className='main-rating-medal-tilt-underlying'
					/>}
					<div className='main-rating-star-list'>
						{Array.from({ length: level }, (_, i) => (
							<img key={i} src='/icons/64px/silver_star.webp' />
						))}
					</div>
					<MedalTilt 
						src={`/ranks/${rating}.webp`} 
					/>
					<p className='main-rating-name'>{name}</p>
				</div>
			</div>
		</>
	)
}